import React from 'react';
import { motion } from 'framer-motion';
import { impactMetrics } from '../../data/impactMetrics';
import { StatCounter } from '../ui/StatCounter';
export function MetricsGrid() {
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-164" data-mp="6ttqzaspznu9">
      {impactMetrics.map((metric, index) => <motion.div key={metric.label} initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-10% 0px'
    }} transition={{
      duration: 0.4,
      delay: index * 0.05,
      ease: [0.23, 1, 0.32, 1]
    }} className="rounded-xl border border-slate-200 bg-white p-8 transition-colors duration-200 hover:border-brandgreen/50" data-id="element-165" data-mp="21k2lz796vu3" data-mpi={index}>
          <StatCounter metric={metric} valueClassName="font-heading text-4xl font-semibold text-navy" labelClassName="mt-3 text-sm leading-relaxed text-charcoal" data-id="element-166" data-mp="ktmcmrpe3dvd" />
        </motion.div>)}
    </div>;
}